import { atom, useRecoilState } from 'recoil';
import { CommentOrderBy } from './types';

export const commentOrderState = atom<CommentOrderBy>({
  key: 'commentOrderAtom',
  default: '-trust_degree',
});

export const useCommentOrder = () => {
  return useRecoilState(commentOrderState);
};
